const isMap = (value) => value !== null && typeof value === 'object'
  && Object.getPrototypeOf(value) === Object.prototype;

export function sameValue(left, right) {
  if (Object.is(left, right)) return true;
  if (Array.isArray(left) && Array.isArray(right)) {
    return left.length === right.length
      && left.every((value, index) => sameValue(value, right[index]));
  }
  if (isMap(left) && isMap(right)) {
    const keys = Object.keys(left);
    return keys.length === Object.keys(right).length
      && keys.every((key) => Object.hasOwn(right, key) && sameValue(left[key], right[key]));
  }
  return false;
}

// Paths are arrays so field names containing dots remain literal field names.
export function draftChanges(source = {}, draft = {}, path = []) {
  const changes = [];
  const before = source || {};
  const after = draft || {};
  new Set([...Object.keys(before), ...Object.keys(after)]).forEach((key) => {
    if (path.length === 0 && key === 'id') return;
    const nextPath = [...path, key];
    if (!Object.hasOwn(after, key)) {
      changes.push({ path: nextPath, removed: true });
    } else if (!sameValue(before[key], after[key])) {
      if (isMap(before[key]) && isMap(after[key]) && Object.keys(after[key]).length > 0) {
        changes.push(...draftChanges(before[key], after[key], nextPath));
      } else {
        changes.push({ path: nextPath, value: after[key] });
      }
    }
  });
  return changes;
}

export function mergeStoreDraft(incoming, source, draft) {
  const result = { ...incoming };
  draftChanges(source, draft).forEach(({ path, value, removed }) => {
    let target = result;
    path.slice(0, -1).forEach((key) => {
      target[key] = isMap(target[key]) ? { ...target[key] } : {};
      target = target[key];
    });
    const key = path[path.length - 1];
    if (removed) delete target[key];
    else target[key] = value;
  });
  return result;
}
